<template>
	<footer
		class="bg-purple-900 text-white pb-36 text-paragraph-size-md"
	>
		<div
			v-if="$slots.footerBar"
			class="py-8 w-full bg-gray-200"
		>
			<div class="container">
				<slot name="footerBar" />
			</div>
		</div>
		<div class="flex flex-col pt-32 gap-32 items-center">
			<div
				class="container grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-24"
			>
				<slot />
			</div>
			<div class="text-white/40 text-paragraph-size-sm text-center px-4">
				<slot name="legal" />
			</div>
		</div>
	</footer>
</template>

<script setup lang="ts">
</script>

<style lang="postcss" scoped>
:deep(h1),
:deep(h2),
:deep(h3),
:deep(h4),
:deep(h5),
:deep(h6) {
    @apply text-purple-100;
}
</style>
